/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

import { CLOCK_TYPE, ITime, WClockComponent } from '../w-clock/w-clock.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatToolbar } from '@angular/material/toolbar';
import { NgClass, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-time',
    templateUrl: './w-time.component.html',
    styleUrls: ['./w-time.component.scss'],
    imports: [FlexModule, ExtendedModule, MatToolbar, NgIf, WClockComponent, MatButton, NgClass]
})
export class WTimeComponent implements OnInit {
  @Input()
  userTime: ITime | null = null;
  @Output()
  userTimeChange: EventEmitter<ITime> = new EventEmitter();

  @Input()
  revertLabel: string | null = null;
  @Input()
  submitLabel: string | null = null;

  @Output()
  revert: EventEmitter<null> = new EventEmitter();
  @Output() done = new EventEmitter<ITime>();

  @Input()
  color: string | null = null;

  public VIEW_HOURS = CLOCK_TYPE.HOURS;
  public VIEW_MINUTES = CLOCK_TYPE.MINUTES;
  public currentView: CLOCK_TYPE = this.VIEW_HOURS;

  constructor() {}

  ngOnInit() {
    if (!this.userTime) {
      this.userTime = {
        hour: 6,
        minute: 0,
        meriden: 'PM',
        format: 12
      };
    }

    if (!this.revertLabel) {
      this.revertLabel = 'Cancel';
    }

    if (!this.submitLabel) {
      this.submitLabel = 'Okay';
    }
  }

  public formatHour(): string {
    if (this.userTime!.format === 24) {
      if (this.userTime!.hour === 24) {
        return '00';
      } else if (this.userTime!.hour < 10) {
        return '0' + String(this.userTime!.hour);
      }
    }
    return String(this.userTime!.hour);
  }

  public formatMinute(): string {
    if (this.userTime!.minute === 0) {
      return '00';
    } else if (this.userTime!.minute < 10) {
      return '0' + String(this.userTime!.minute);
    } else {
      return String(this.userTime!.minute);
    }
  }

  public setCurrentView(type: CLOCK_TYPE) {
    this.currentView = type;
  }

  public setMeridien(m: 'PM' | 'AM') {
    this.userTime!.meriden = m;
  }

  public emituserTimeChange() {
    this.userTimeChange.emit(this.userTime!);
  }
}
